module.exports = __webpack_public_path__ + "img/website.c6556577.svg";